import { Trans } from 'react-i18next';

import { Anchor, Body2 } from '@myphx-engineering/phx-design-system';

import { useDrugKey } from '../../../../../hooks/use-drug-key';
import { useProgramTerms } from '../../../../../hooks/use-program-terms';
import { getAbsoluteRoute } from '../../../../../util/get-absolute-route';
import { isPharmacySpecificOffer } from '../../../../../util/offers/is-pharmacy-specific-offer';
import type { PricingCardElementProps } from '../../common/shared';

export const SelfPayAssistancePricingTerms = ({
    hasIncentiveProgram,
    medication,
    offer,
}: Omit<PricingCardElementProps, 'patientPay' | 'priceType' | 'savings'>) => {
    const drugKey = useDrugKey(medication);
    const terms = useProgramTerms(medication, 'self-pay');

    if (
        hasIncentiveProgram ||
        !drugKey ||
        !terms ||
        isPharmacySpecificOffer(offer)
    ) {
        return null;
    }

    const href =
        terms.termsUrl ??
        getAbsoluteRoute('programs.drugKey.terms.pathway', {
            drugKey,
            pathway: 'self-pay',
        });

    return (
        <Body2>
            <Trans
                i18nKey="fill.pricing.seeTerms"
                components={{
                    1: (
                        <Anchor
                            href={href}
                            target={terms.termsUrl ? '_blank' : undefined}
                        />
                    ),
                }}
            />
        </Body2>
    );
};
